<template>
  <page-outline 
    :title="listTitle"
    :show-filter="true"
    :show-refresh="true"
    :show-extract="canExtract"
    :filter-expanded="displayFilter"
    :refresh-disabled="activateSpinnerVopHistory || activateSpinnerVopMessage || activateSpinnerVopResponse"
    :extract-disabled="activateSpinnerVopHistory || activateSpinnerVopMessage || activateSpinnerVopResponse"
    @toggle-filter="toggleFilterDisplay"
    @refresh="refreshMessages"
    @extract="exportMessages">
    <template slot="navigationTabs">
      <!-- Version Mobile - 1 colonne avec plusieurs lignes -->
      <div class="d-block d-lg-none">
        <div class="d-flex flex-column">
          <app-button
            v-for="(tab, index) in tabs"
            :key="index"
            :text="$t(tab.translationKey)"
            :variant="tabName === index ? 'primary' : 'light'"
            size="md"
            :block="true"
            custom-class="mb-2"
            :aria-pressed="tabName === index ? 'true' : 'false'"
            @click="tabName = index"
          />
        </div>
      </div>
      
      <!-- Version Desktop - Onglets Bootstrap qui prennent toute la largeur -->
      <div class="d-none d-lg-block">
        <b-nav tabs fill class="border-0">
          <b-nav-item
            v-for="(tab, index) in tabs"
            :key="index"
            :active="tabName === index"
            @click="tabName = index"
            :class="{'bg-primary text-white': tabName === index}"
          >
            {{ $t(tab.translationKey) }}
          </b-nav-item>
        </b-nav>
      </div>
    </template>
    
    <template slot="filterContent">
      <app-panel
        :filters="filterConfig"
        :searchAriaLabel="$t('common.srch') + ' ' + $t('common.monitoring.statistics')"
        @filter-changed="onFilterChanged"
        @clear-filters="clearFilterFields"
        @apply-filters="applyFilter"
      />
    </template>
    
    <template slot="pageContent">
      <b-container fluid>
        <b-tabs v-model="tabName" @input="onTabChange" nav-class="d-none">
          <b-tab :title="$t('common.monitoring.distribution_vop_response_status')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopResponse"></spinner>
              <b-col v-else-if="pieChartDataStatus" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.distribution_vop_response_status") }}
                </h3>
                <pie-chart
                  ref="pieChartStatus"
                  :chart-id="'pie-chart-status'"
                  :chart-data="pieChartDataStatus"
                  :options="chartOptionsStatus">
                </pie-chart>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="$t('common.monitoring.time_distribution_by_processing_connector')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopHistory"></spinner>
              <b-col v-else-if="pieChartDataConnector" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.time_distribution_by_processing_connector") }}
                </h3>
                <pie-chart
                  ref="pieChartConnector"
                  :chart-id="'pie-chart-connector'"
                  :chart-data="pieChartDataConnector"
                  :options="chartOptionsConnector">
                </pie-chart>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab :title="$t('common.monitoring.distribution_of_requests')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopMessage"></spinner>
              <b-col v-else-if="pieChartDataRequest" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.distribution_of_requests") }}
                </h3>
                <pie-chart
                  ref="pieChartRequest"
                  :chart-id="'pie-chart-request'"
                  :chart-data="pieChartDataRequest"
                  :options="chartOptionsRequest">
                </pie-chart>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab v-if="flagCACP" :title="$t('common.monitoring.average_duration_per_processing_step_messages')">
            <b-row class="justify-content-center mt-5">
              <spinner v-if="activateSpinnerVopHistory"></spinner>
              <b-col v-else-if="lineChartData" cols="12">
                <h3 class="text-center">
                  {{ $t("common.monitoring.average_duration_per_processing_step_messages") }}
                </h3>
                <line-chart
                  ref="lineChart"
                  :chart-id="'line-chart-duration'"
                  :chart-data="lineChartData"
                  :options="chartOptionsLine">
                </line-chart>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import AppButton from '@/components/common/AppButton.vue'
import AppPanel from '@/components/common/AppPanel.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import { Chart as ChartJS } from "chart.js"
import { Line } from "vue-chartjs"
import { Pie } from "vue-chartjs"
import ChartDataLabels from "chartjs-plugin-datalabels"
import moment from "moment-timezone"
import * as XLSX from 'xlsx'
import conf from "@/config/config.dev";

export default {
  name: "VopMessagePage",
  components: {
    'datetime-picker-custom': dateTimePicker,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner,
    AppButton,
    'app-panel': AppPanel,
    "line-chart": {
      extends: Line,
      props: ["chartData", "options", "chartId"],
      mounted() {
        // this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, { ...this.options, plugins: { ...this.options.plugins, id: this.chartId } })
      },
    },
    "pie-chart": {
      extends: Pie,
      props: ["chartData", "options", "chartId"],
      mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(this.chartData, { ...this.options, plugins: { ...this.options.plugins, id: this.chartId } })
      }
    }
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      listEngineDown: [],
      activateSpinnerVopHistory: false,
      activateSpinnerVopMessage: false,
      activateSpinnerVopResponse: false,
      chartOptionsConnector: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            bottom: 20
          }
        }
      },
      chartOptionsLine: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: "time",
            time: {
              unit: "hour",
            },
          },
        },
      },
      chartOptionsRequest: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#fff",
            font: {
              weight: "bold",
            },
          }
        },
      },
      chartOptionsStatus: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let total = ctx.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
              )
              let percentage = ''
              if (total !== 0 && value !== 0) {
                percentage = ((value / total) * 100).toFixed(2) + "%"
              }
              return percentage
            },
            color: "#000",
            font: {
              weight: "bold",
            },
          }
        }
      },
      dateEnd: '',
      dateStart: '',
      orgnlDateEnd: '',
      orgnlDateStart: '',
      orgnlStatusType: 'ALL',
      displayFilter: false,
      elementSearchedVopHistory: "",
      elementSearchedVopMessage: "",
      elementSearchedVopResponse: "",
      lineChartData: null,
      lineChartLabels: [],
      listItemsHistory: [],
      listItemsMessage: [],
      listItemsRequest: [],
      listItemsResponse: [],
      listTitle: "",
      flagBPCE: conf.visual != 'BPCE' ? false : true,
      flagCACP: conf.visual != 'CACP' ? false : true,
      pieChartDataConnector: null,
      pieChartDataStatus: null,
      pieChartDataRequest: null,
      refreshKey: false,
      StatusType: 'ALL',
      tabName: 0,

      timezone: '+00:00'
    }
  },
  computed: {
    tabs() {
      if (this.flagCACP) {
        return [
          { translationKey: 'common.monitoring.distribution_vop_response_status' },
          // { translationKey: 'common.monitoring.time_distribution_by_processing_step' },
          { translationKey: 'common.monitoring.time_distribution_by_processing_connector' },
          { translationKey: 'common.monitoring.distribution_of_requests' },
          { translationKey: 'common.monitoring.average_duration_per_processing_step_messages' }
        ]
      }
      else {
        return [
          { translationKey: 'common.monitoring.distribution_vop_response_status' },
          // { translationKey: 'common.monitoring.time_distribution_by_processing_step' },
          { translationKey: 'common.monitoring.time_distribution_by_processing_connector' },
          { translationKey: 'common.monitoring.distribution_of_requests' },
        ]
      }
    },
    canExtract() {
      return this.listItemsResponse.length > 0 || this.listItemsMessage.length > 0 || this.listItemsHistory.length > 0
    },
    totalFiltersCount() {
      // Compter le nombre de filtres affichés
      let count = 2; // Date début + Date fin (toujours affichés)
      
      // Ajouter StatusType si affiché
      if (this.tabName != 0 && !this.flagBPCE) {
        count += 1;
      }
      
      return count;
    },
    filterConfig() {
      const filters = []
      const hasStatusFilter = this.tabName != 0 && !this.flagBPCE
      
      // Filtre StatusType conditionnel
      if (hasStatusFilter) {
        filters.push({
          id: 'monitoring-status',
          type: 'select',
          prop: 'StatusType',
          labelKey: 'common.monitoring.status_type',
          icon: 'fa-solid fa-flag',
          value: this.StatusType,
          colSm: '12',
          colLg: '4',
          defaultOptionKey: 'common.monitoring.select_placeholder',
          options: [
            { value: 'ALL', labelKey: 'common.monitoring.all' },
            { value: 'DDV', labelKey: 'common.monitoring.ddv_status' },
            { value: 'DDD', labelKey: 'common.monitoring.ddd_status' }
          ]
        })
      }
      
      // Filtres de dates toujours présents
      filters.push(
        {
          id: 'date-start',
          type: 'datetime',
          prop: 'dateStart',
          labelKey: 'common.monitoring.date_start',
          icon: 'fa-solid fa-calendar-days',
          value: this.dateStart,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: hasStatusFilter ? '6' : '12',
          colLg: hasStatusFilter ? '4' : '6'
        },
        {
          id: 'date-end',
          type: 'datetime',
          prop: 'dateEnd',
          labelKey: 'common.monitoring.date_end',
          icon: 'fa-solid fa-calendar-days',
          value: this.dateEnd,
          format: 'DD/MM/YYYY H:i:s',
          maxLength: 19,
          colSm: hasStatusFilter ? '6' : '12',
          colLg: hasStatusFilter ? '4' : '6'
        }
      )
      
      return filters
    }
  },
  created() {
    this.timezone = moment.tz.guess()
    const offsetMinutes = moment().utcOffset()
    const sign = offsetMinutes >= 0 ? '+' : '-'
    const absOffset = Math.abs(offsetMinutes)
    const hours = String(Math.floor(absOffset / 60)).padStart(2, '0')
    const minutes = String(absOffset % 60).padStart(2, '0')
    this.timezone = `${sign}${hours}:${minutes}`
    // this.dateStart = moment().subtract(1, 'day').format('DD/MM/YYYY HH:mm:ss')
    Chart.Legend.prototype.afterFit = function() {
      this.height = this.height + 50;
    }
    this.orgnlDateStart = this.dateStart
    this.listTitle = this.$i18n.t('Webheader.vopMessage')
    this.activateSpinnerVopHistory = true
    this.activateSpinnerVopMessage = true
    this.activateSpinnerVopResponse = true
    this.getVopHistory()

    if (this.id !== "-1") {
      this.tabName = parseInt(this.id)
    }
  },
  watch: {
    tabName(newVal) {
      this.$nextTick(() => {
        this.onTabChange(newVal)
      })
    }
  },
  methods: {
    async fetchVopHistoryAndMerge(filterConditions) {
      this.listEngineDown = []
        let that = this
        let requests = []
        let listEngineDownLocal = []

        for (let i = 0; i < this.$engine.length; i++) {
          const engine = this.$engine.engines[i]
          if (engine.common.network.state === 'offline') {
            continue
          }
          if (engine?.monitoring?.vopHistory?.fetch) {
            try {
              const resp = await engine.monitoring.vopHistory.fetch(filterConditions)
              let vopHistoryList = {}
              vopHistoryList = resp.data.VopHistory
              this.lineChartLabels = [...new Set(vopHistoryList.map(item => moment.utc(item.Hour).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS')))].sort()

              const taggedTracks = vopHistoryList.map(item => ({
                ...item,
                engineIndex: i
              }))
              requests.push(...taggedTracks)

              this.$f7.pullToRefreshDone()
              that.activateSpinnerVopHistory = false

            } catch (error) {
              listEngineDownLocal.push({
                host: engine?.common?.network?.info?.host || 'unknown',
                error: error,
                engineIndex: i,
              })
              this.listEngineDown = [...this.listEngineDown, ...listEngineDownLocal]
              continue
            }
          }
        }




        if (listEngineDownLocal.length === this.$engine.length) {
          errorMessageAlert(listEngineDownLocal[0].error, this)
        } else {
          that.updateVopHistory(requests)
          that.generateLineChartData(requests)
          that.generatePieChartDataConnector(requests)
          this.activateSpinnerVopHistory = false
        }
      this.listEngineDown = [...this.listEngineDown, ...listEngineDownLocal]

    },
    async fetchVopMessageAndMerge(filterConditions) {
      let that = this
      let requests = []
      let listEngineDownLocal = []

      for (let i = 0; i < this.$engine.length; i++) {
        const engine = this.$engine.engines[i]
        if (engine.common.network.state === 'offline') {
          continue
        }
        if (engine?.monitoring?.vopMessage?.fetch  && this.listEngineDown.find(element =>  element.engineIndex === i) == undefined) {
          try {
            const resp = await engine.monitoring.vopMessage.fetch(filterConditions)
              let vopMessageList = {}

              vopMessageList = resp.data.VopMessage

              const taggedTracks = vopMessageList.map(item => ({
                ...item,
                engineIndex: i
              }))
              requests.push(...taggedTracks)

              this.$f7.pullToRefreshDone()
            }
          catch (error) {
            listEngineDownLocal.push({
              host: engine?.common?.network?.info?.host || 'unknown',
              error: error,
              engineIndex: i,
            })
            this.listEngineDown = [...this.listEngineDown, ...listEngineDownLocal]

            continue
          }
        }
      }

      if (listEngineDownLocal.length === this.$engine.length) {
        errorMessageAlert(listEngineDownLocal[0].error, this)
      } else {
        that.updateVopMessage(requests)
        that.generatePieChartDataRequest(requests)
        this.activateSpinnerVopMessage = false
      }
      this.listEngineDown = [...this.listEngineDown, ...listEngineDownLocal]
    },
    async fetchVopResponseAndMerge (filterConditions) {
      let that = this
      let requests = []
      let listEngineDownLocal = []

      for (let i = 0; i < this.$engine.length; i++) {

        const engine = this.$engine.engines[i]
        if (engine.common.network.state === 'offline') {
          continue
        }

        if (engine?.monitoring?.vopResponse?.fetch && this.listEngineDown.find(element => element.engineIndex === i) == undefined) try {
          let resp = await engine.monitoring.vopResponse.fetch(filterConditions)
          let vopResponseList = {}
          vopResponseList = resp.data.VopResponse

          this.$f7.pullToRefreshDone()

            const taggedTracks = vopResponseList.map(item => ({
              ...item,
              engineIndex: i
            }))
            requests.push(...taggedTracks)

            this.$f7.pullToRefreshDone()
        } catch (error) {
          listEngineDownLocal.push({
            host: engine?.common?.network?.info?.host || 'unknown',
            error: error,
            engineIndex: i,
          })
          this.listEngineDown = [...this.listEngineDown, ...listEngineDownLocal]
          continue
        }
      }


        if (listEngineDownLocal.length === this.$engine.length) {
          errorMessageAlert(listEngineDownLocal[0].error, this)
        } else {
          that.updateVopResponse(requests)
          that.generatePieChartDataStatus(requests)
          that.activateSpinnerVopResponse = false
        }
      this.listEngineDown = [...this.listEngineDown, ...listEngineDownLocal]
      },
    checkEnginesDown(listEngineDownLocal) {
      if (!listEngineDownLocal || listEngineDownLocal.length === 0) {
        return false; // Aucun problème
      }

      const firstEngineDown = listEngineDownLocal[0];


      return true;
    },
    applyFilter() {
      this.activateSpinnerVopHistory = true
      this.activateSpinnerVopMessage = true
      this.activateSpinnerVopResponse = true
      this.getVopHistory()
      this.getVopMessage()
      this.getVopResponse()
    },
    arrayBufferToBase64(buffer) {
      let binary = ''
      let bytes = new Uint8Array(buffer)
      let length = bytes.length
      for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    },
    onFilterChanged ({ prop, value }) {
      this[prop] = value
    },
    clearFilterFields() {
      this.StatusType = this.orgnlStatusType
      this.dateStart = this.orgnlDateStart
      this.dateEnd = this.orgnlDateEnd
      // this.applyFilter()
    },
    extractXLSX() {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let wb = XLSX.utils.book_new()
      if (this.listItemsResponse.length > 0) {
        let responseData = []
        responseData.push([this.$t('common.monitoring.status'), this.$t('common.monitoring.nb_result')])
        this.listItemsResponse.forEach(result => {
          let statusCode = {
            "MTCH": "Match",
            "NMTC": "No Match",
            "CMTC": "Close Match",
            "NOAP": "Not Applicable",
            "": this.$t('tracking.no_result')
          }[result.Status] || result.Status
          responseData.push([statusCode, result.NbVopResponse])
        })
        let ws1 = XLSX.utils.aoa_to_sheet(responseData)
        XLSX.utils.book_append_sheet(wb, ws1, this.$t('common.monitoring.distribution_vop_response_status').substring(0, 31))
      }
      if (this.listItemsHistory.length > 0) {
        let historyData = []
        historyData.push([this.$t('common.monitoring.processing_step'), this.$t('common.monitoring.time_ms')])
        let connectorDurations = {}
        let countValue = {}
        this.listItemsHistory.forEach(result => {
          let connector = result.Connector
          let timeDiff = Number(result.TimeDiffMicroseconds) || 0
          if (connectorDurations[connector] !== undefined) {
            connectorDurations[connector] += timeDiff
            countValue[connector]++
          } else {
            connectorDurations[connector] = timeDiff
            countValue[connector] = 1
          }
        })
        for (let key in countValue) {
          connectorDurations[key] /= countValue[key]
        }
        Object.keys(connectorDurations).forEach(connector => {
          let connectorLabel = this.$t('common.monitoring.' + connector.replace(/\s+/g, ''))
          let averageTimeMs = Number((connectorDurations[connector] * 1000).toFixed(2))
          historyData.push([connectorLabel, averageTimeMs + ' (ms)'])
        })
        let ws2 = XLSX.utils.aoa_to_sheet(historyData)
        let sheetName = this.$t('common.monitoring.time_distribution_by_processing_connector').substring(0, 31)
        XLSX.utils.book_append_sheet(wb, ws2, sheetName)
      }
      if (this.listItemsMessage.length > 0) {
        let messageData = []
        messageData.push([this.$t('common.monitoring.status'), this.$t('common.monitoring.nb_result')])
        this.listItemsMessage.forEach(result => {
          if (result.OK) messageData.push([this.$t('common.monitoring.success'), result.OK])
          if (result.KO) messageData.push([this.$t('common.monitoring.technical_failure'), result.KO])
        })
        let ws3 = XLSX.utils.aoa_to_sheet(messageData)
        XLSX.utils.book_append_sheet(wb, ws3, this.$t('common.monitoring.distribution_of_requests').substring(0, 31))
      }
      if (this.listItemsHistory.length > 0) {
        let avgDurationData = []
        avgDurationData.push([this.$t('common.monitoring.date_time'), this.$t('common.monitoring.processing_step'), this.$t('common.monitoring.time_ms')])
        this.listItemsHistory.forEach(result => {
          let formattedHour = moment.utc(result.Hour).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS')
          let timeDiffInMs = Number((result.TimeDiffMicroseconds * 1000).toFixed(2))
          let connectorLabel = this.$t('common.monitoring.' + result.Connector.replace(/\s+/g, ''))
          avgDurationData.push([formattedHour, connectorLabel, timeDiffInMs + ' (ms)'])
        })
        let ws4 = XLSX.utils.aoa_to_sheet(avgDurationData)
        XLSX.utils.book_append_sheet(wb, ws4, this.$t('common.monitoring.average_duration_per_processing_step_messages').substring(0, 31))
      }
      this.$f7.hidePreloader()
      let wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'array'})
      let linkSource = 'data:application/octet-stream;base64,' + this.arrayBufferToBase64(wbout)
      let downloadLink = document.createElement('a')
      let today = moment().tz(this.timezone).unix()
      let fileName = this.$t('common.monitoring.statistics') + '_' + today + '.xlsx'
      if (this.$f7.device.os === 'android' || this.$f7.device.os === 'ios') {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    generateLineChartData(vopHistoryData) {
      const datasets = {}
      vopHistoryData.forEach((item) => {
        const connector = item.Connector
        const deltaTime = Number(item.TimeDiffMicroseconds) * 1000 || 0
        if (!datasets[connector]) {
          datasets[connector] = {
            label: this.$t('common.monitoring.' + connector.replace(' ', '')),
            data: new Array(this.lineChartLabels.length).fill(0),
            borderColor: this.getCustomColor(connector),
            backgroundColor: this.getCustomColor(connector, 0.8),
            fill: false,
          }
        }
        const hourIndex = this.lineChartLabels.indexOf(moment.utc(item.Hour).tz(this.timezone).format('DD/MM/YYYY HH:mm:ss.SSS'))
        if (hourIndex !== -1) {
          datasets[connector].data[hourIndex] += deltaTime
        }
      })
      this.lineChartData = {
        labels: this.lineChartLabels,
        datasets: Object.values(datasets),
      }
      this.$nextTick(() => {
        this.$refs.lineChart &&
        this.$refs.lineChart.renderChart(
            this.lineChartData,
            this.chartOptionsLine
        )
      })
    },
    generatePieChartDataConnector(vopHistoryData) {
      let connectorDurations = {}
      let countValue = {}
      vopHistoryData.forEach((item) => {
        let connector = item.Connector
        let timeDiff = Number(item.TimeDiffMicroseconds) || 0
        if (connectorDurations[connector] !== undefined) {
          connectorDurations[connector] += timeDiff
          countValue[connector]++
        } else {
          connectorDurations[connector] = timeDiff
          countValue[connector] = 1
        }
      })
      for (let key in countValue) {
        connectorDurations[key] /= countValue[key]
      }
      let labels = Object.keys(connectorDurations).map((label) => this.$t('common.monitoring.' + label.replace(' ', '')))
      let durations = Object.values(connectorDurations).map((duration) => Number((duration * 1000).toFixed(2)))
      let colors = Object.keys(connectorDurations).map((label) => this.getCustomColor(label, 0.8))
      this.pieChartDataConnector = {
        labels: labels,
        datasets: [
          {
            data: durations,
            backgroundColor: colors,
            datalabels: {
              formatter: (value, ctx) => {
                return `${value} (ms)`
              },
              color: "#000",
              font: {
                weight: "bold",
              },
              anchor: 'end',
              align: 'end',
              clamp: true,
            },
          },
        ],
      }
      this.$nextTick(() => {
        this.$refs.pieChartConnector &&
        this.$refs.pieChartConnector.renderChart(
            this.pieChartDataConnector,
            this.chartOptionsConnector
        )
      })
    },
    generatePieChartDataStatus(vopResponseData) {
      let filteredResponses = vopResponseData.filter((item) => item.Status)
      let statusCounts = {
        MATCH: 0,
        NOMATCH: 0,
        CLOSEMATCH: 0,
        NOAP: 0
      }
      filteredResponses.forEach((item) => {
        switch (item.Status) {
          case 'MTCH':
            statusCounts.MATCH = parseInt(item.NbVopResponse)
            break
          case 'NMTC':
            statusCounts.NOMATCH = parseInt(item.NbVopResponse)
            break
          case 'CMTC':
            statusCounts.CLOSEMATCH = parseInt(item.NbVopResponse)
            break
          case 'NOAP':
            statusCounts.NOAP = parseInt(item.NbVopResponse)
            break
          default:
            break
        }
      })
      let colors = [
        this.getCustomColor('MTCH', 0.8),
        this.getCustomColor('NMTC', 0.8),
        this.getCustomColor('CMTC', 0.8),
        this.getCustomColor('NOAP', 0.8),
      ]
      this.pieChartDataStatus = {
        labels: ['Match', 'No Match', 'Close Match', 'Not Applicable'],
        datasets: [
          {
            data: [
              statusCounts.MATCH,
              statusCounts.NOMATCH,
              statusCounts.CLOSEMATCH,
              statusCounts.NOAP,
            ],
            backgroundColor: colors,
          },
        ],
      }
      this.$nextTick(() => {
        this.$refs.pieChartStatus &&
        this.$refs.pieChartStatus.renderChart(
            this.pieChartDataStatus,
            this.chartOptionsStatus
        )
      })
    },
    generatePieChartDataRequest(vopMessageData) {
      if (vopMessageData.length > 0) {
        let colors = [
          this.getCustomColor('MTCH', 0.8),
          this.getCustomColor('NMTC', 0.8)
        ]
        this.pieChartDataRequest = {
          labels: [
            this.$t("common.monitoring.success"),
            this.$t("common.monitoring.technical_failure"),
          ],
          datasets: [
            {
              data: [parseInt(vopMessageData[0].OK), parseInt(vopMessageData[0].KO)],
              backgroundColor: colors,
            },
          ],
        }
        this.$nextTick(() => {
          this.$refs.pieChartRequest &&
          this.$refs.pieChartRequest.renderChart(
              this.pieChartDataRequest,
              this.chartOptionsRequest
          )
        })
      }
    },
    getCustomColor(key, alpha = 1) {
      let r, g, b
      r = Math.floor(Math.random() * 256)
      g = Math.floor(Math.random() * 256)
      b = Math.floor(Math.random() * 256)
      switch (key) {
        case 'CMTC': // Orange vif
          r = 230;
          g = 159;
          b = 0;
          break;
        case 'connector 1': // Violet moyen
          r = 117;
          g = 112;
          b = 179;
          break;
        case 'connector 2': // Bleu clair
          r = 86;
          g = 180;
          b = 233;
          break;
        case 'connector 3': // Gris neutre
        case 'NOAP': // Gris neutre
          r = 153;
          g = 153;
          b = 153;
          break;
        case 'connector 4': // Vert turquoise clair
          r = 0;
          g = 158;
          b = 115;
          break;
        case 'connector 5': // Bleu profond
          r = 0;
          g = 114;
          b = 178;
          break;
        case 'connector 6': // Brun chaud
          r = 213;
          g = 94;
          b = 0;
          break;
        case 'connector 7': // Cyan clair
          r = 0;
          g = 204;
          b = 204;
          break;
        case 'MTCH': // Vert foncé
          r = 0;
          g = 143;
          b = 57;
          break;
        case 'NMTC': // Rouge atténué
          r = 204;
          g = 0;
          b = 0;
          break;
        case '': // Vide ou non spécifié
          break;
      }
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    getRandomColor(alpha = 1) {
      const r = Math.floor(Math.random() * 256)
      const g = Math.floor(Math.random() * 256)
      const b = Math.floor(Math.random() * 256)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    async getVopHistory() {
      let params = {
        StatusType: this.StatusType,
        DateStart: this.dateStart != '' ? moment(this.dateStart, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        DateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      }
      await this.fetchVopHistoryAndMerge(params)

      this.getVopMessage()
    },
    async getVopMessage() {
      let params = {
        name: this.elementSearchedVopMessage,
        StatusType: this.StatusType,
        DateStart: this.dateStart != '' ? moment(this.dateStart, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        DateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      }
      await this.fetchVopMessageAndMerge(params)

      this.getVopResponse()
    },
    getVopResponse() {
      let params = {
        name: this.elementSearchedVopResponse,
        DateStart: this.dateStart != '' ? moment(this.dateStart, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : '',
        DateEnd: this.dateEnd != '' ? moment(this.dateEnd, 'DD/MM/YYYY HH:mm:ss.SSSZ').format('YYYY-MM-DDTHH:mm:ss.SSSZ') : ''
      }
      this.fetchVopResponseAndMerge(params)
    },
    toggleFilterDisplay() {
      this.displayFilter = !this.displayFilter
    },
    refreshMessages() {
      this.onRefresh()
    },
    exportMessages() {
      this.extractXLSX()
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinnerVopHistory = true
      this.activateSpinnerVopMessage = true
      this.activateSpinnerVopResponse = true
      this.getVopHistory()
      this.getVopMessage()
      this.getVopResponse()
    },
    onTabChange(index) {
      const charts = [
        {
          ref: this.$refs.pieChartStatus,
          data: this.pieChartDataStatus,
          options: this.chartOptionsStatus
        },
        {
          ref: this.$refs.pieChartConnector,
          data: this.pieChartDataConnector,
          options: this.chartOptionsConnector
        },
        {
          ref: this.$refs.pieChartRequest,
          data: this.pieChartDataRequest,
          options: this.chartOptionsRequest
        },
        {
          ref: this.$refs.lineChart,
          data: this.lineChartData,
          options: this.chartOptionsLine
        }
      ]
      const chart = charts[index]
      if (chart && chart.ref) {
        chart.ref.renderChart(chart.data, chart.options)
      }
      // Gérer le spinner si nécessaire
      // this.$nextTick(() => {
      //   this.activateSpinner = false
      // })
    },
    updateVopHistory(vopHistoryList) {
      this.listItemsHistory = vopHistoryList
    },
    updateVopMessage(vopMessageList)
    {
      this.listItemsMessage = vopMessageList
    },
    updateVopResponse(vopResponseList)
    {
      this.listItemsResponse = vopResponseList
    }
  }
}
</script>

<style scoped>

@media (max-width: 1400px) {
  .responsive-button {
    min-height: 100px;
  }
}

@media (max-width: 1400px) {
  .responsive-button2 {
    max-height: 70px;
  }
}

/* Styles pour les onglets de navigation */
::v-deep .nav-tabs .nav-item {
  text-align: center;
}

/* Version desktop - onglets qui prennent toute la largeur */
@media (min-width: 992px) {
  ::v-deep .nav-tabs.nav-fill .nav-item {
    flex: 1;
  }
}

/* Version mobile - onglets alignés horizontalement */
@media (max-width: 991px) {
  .overflow-auto {
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
  }
  
  ::v-deep .nav-tabs.flex-nowrap {
    width: max-content;
  }
  
  ::v-deep .nav-tabs.flex-nowrap .nav-item {
    flex: 0 0 auto;
  }
}

::v-deep .nav-tabs .nav-link {
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  color: #495057;
  padding: 0.75rem 1rem;
  transition: all 0.3s ease;
  white-space: nowrap;
}

::v-deep .nav-tabs .nav-link:hover {
  background-color: #e9ecef;
  border-color: #adb5bd;
}

::v-deep .nav-tabs .nav-link.active {
  background-color: var(--actionButtonColor, #0d7e7d) !important;
  color: white !important;
  border-color: var(--actionButtonColor, #0d7e7d) !important;
  font-weight: bold;
}

::v-deep .nav-tabs .nav-link.active:hover {
  background-color: var(--actionButtonHoverColor, #0e8e8d) !important;
}
</style>
